<nz-avatar-group>
  <nz-avatar
    *ngFor="let user of users | sliceArray:0:numberVisibleElements; index as i"
    (click)="onEmitUserSelected(user)"
    nz-popover=""
    nzPopoverTitle=""
    [nzPopoverContent]="selectable ? 'clic para mostrar a ' + user.name + ' ' + user.lastname : user.name + ' ' + user.lastname"
    [ngStyle]="{'background-color': colors[i]}"
    [nzText]="(user.name ? user.name[0] : '') + '' + (user.lastname ? user.lastname[0] : '')"
    [nzSrc]="user.profileImageURL ? user.profileImageURL : ''"
    (nzError)="loadDefaultImage(user._id, (user.experts && user.experts.length> 0) ? 'expert':
    (user.patients && user.patients.length > 0) ? 'patient': 'not-defined')"
    [ngClass]="{'background-default-color': user.avatarDefaultBackgroundColor}"
    >
  </nz-avatar>
  <nz-avatar *ngIf="users && users.length> numberVisibleElements" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="moreTpl" [nzText]=" '+' +
    (users.length - numberVisibleElements)"></nz-avatar>
  <ng-template #moreTpl>
    <div class="content-description">
      <p class="more-avatar truncate" [class.cursor-pointer]="selectable" *ngFor="let user of users | sliceArray:numberVisibleElements; index as i">
        <nz-avatar
          (click)="onEmitUserSelected(user)"
          [ngStyle]="{'background-color': colors[i]}"
          [nzText]="!user.profileImageURL ? (user.name ? user.name[0] : '') + '' + (user.lastname ? user.lastname[0] : '') : ''"
          [nzSrc]="user.profileImageURL ? user.profileImageURL : ''"></nz-avatar>
        {{ user.name + ' ' + user.lastname }}
      </p>
    </div>
  </ng-template>
</nz-avatar-group>
